import pqGuardDogLogo from '@/assets/logo-128w.webp';
import { Anchor, Button, Divider, Image, Stack, Text, Timeline, Title } from "@mantine/core";
import { IconCheck, IconExclamationMark, IconFileInfo, IconQuestionMark, IconSearch } from "@tabler/icons-react";
import React, { useEffect } from "react";
import { useNavigate } from "react-router";
const Welcome: React.FC = () => {

  const navigate = useNavigate();
  const onRegisterClick = () => {
    navigate('/register');
  }
  useEffect(() => {
    document.title = "Welcome - Guard Dog Real Estate Protection Service";
  }, []);
  return (
    <Stack>
      <Stack align='center' justify='center' mb={80}>
        <Anchor href='/'>
          <Image style={{objectFit: 'contain'}} src={pqGuardDogLogo} alt='Guard Dog Service' height={120} />
        </Anchor>
        <Title style={{ textAlign: 'center', fontFamily: 'Elston, sans-serif', letterSpacing: '2px' }} order={1}>Free<br />Real Estate Protection Service</Title>
      </Stack>
      <Text style={{fontWeight: 'bold'}}>Guard Dog is a FREE real estate protection service that alerts you by email if a document is recorded, which affects a property or name registered in your Guard Dog account.</Text>
      <Text>Using cutting-edge technology with 24/7 monitoring, Guard Dog helps protect your identity, credit, home, and property title from fraudulent ownership transfers and liens.</Text>
      <Text>Enroll now in less than 5 minutes with a notification email address plus the county, owner names, and properties you wish to have guarded.</Text>
      <Divider />
      <Title order={2}>How it Works</Title>
      <Timeline active={2} bulletSize={24} lineWidth={4}>
        <Timeline.Item title="Sign Up" bullet={<IconCheck size={12} />}>
          <Text size='sm'>Sign up on the next page using your email address and register the names and properties you wish to have guarded. Properties can be registered by address or APN</Text>
          <Text mt={4} size="xs">APN is the Assessor Parcel Number, a unique number assigned to each property.</Text>
        </Timeline.Item>
        <Timeline.Item title="Monitor" bullet={<IconSearch size={12} />}>
          <Text size='sm'>Guard Dog continuously monitors the county recorder's Official Records Index looking for documents affecting any of the properties or names you've registered for guarding.</Text>
          <Text mt={4} size="xs">This includes liens recorded and placed on personal, business, and trust names you've registered for guarding.</Text>
        </Timeline.Item>
        <Timeline.Item title="Detect and Alert" bullet={<IconExclamationMark size={12} />}>
          <Text size='sm'>If a document is recorded which affects one of your guarded items, Guard Dog immediately sends an email alert to all of notification methods in your account.</Text>
        </Timeline.Item>
      </Timeline>
      <br />
      <Timeline active={-1} bulletSize={24} lineWidth={0}>
        <Timeline.Item title="Report Fraud" lineVariant="dashed" bullet={<IconQuestionMark size={12} />}>
          <Text size='sm'>If you suspect you are a victim of fraud, immediately follow the instructions in the Recording Alert email sent to you by Guard Dog or contact the recorder's office in the county in which the suspect document was recorded. See the county's website for contact information.</Text>
        </Timeline.Item>
        <Timeline.Item title="Remember" bullet={<IconFileInfo size={12} />}>
          <Text size='sm'>This service only applies to documents recorded after your Guard Dog subscription has been activated and for properties and owner names you've registered for guarding.</Text>
          <Text mt={4} size="xs">Not all APNs and names are entered in the Official Records Index</Text>
          <Text mt={4} size="xs">Subscriptions guarding common surnames and/or first names may receive additional notifications that may not apply to the subscriber.</Text>
        </Timeline.Item>
      </Timeline>
      <br />
      <Button onClick={onRegisterClick} size='lg' color='pq-red' radius='md' mb='80px' ml='30px' w={'33dvw'}>
        Next
      </Button>
    </Stack>
  );
}

export default Welcome;